export default __webpack_public_path__ + "static/media/TK.998d31e9.ico";